import { useLayoutEffect, useRef } from "react"
import step2Style from "../step2.module.css"


export default function Info(props) {

    const academyInfo = props['academyInfo']
    const noticeList = props['noticeList']

    const notice = useRef()

    useLayoutEffect(() => {
        if(noticeList.length > 0) {
            notice.current.innerHTML = noticeList[0]['content']
        }
    }, [noticeList])

    return(
        <div className={step2Style['infoWrap']}>
            <div className={step2Style['branchName']}>{academyInfo["BranchName"]}</div>
            <div className={step2Style['address']}>{academyInfo["Addr1"]} {academyInfo["Addr2"]}</div>
            <div style={{marginBottom: "10px"}}>
                {academyInfo["Phone"] &&
                    <a href={`tel:${academyInfo["Phone"]}`} target="_blank">전화</a>
                }
                {academyInfo["Homepage"] &&
                <>
                    <span style={{marginInline: "5px"}}>|</span>
                    <a href={academyInfo["Homepage"]} target="_blank">홈페이지</a>
                </>
                }
                {academyInfo["Blog"] &&
                <>
                    <span style={{marginInline: "5px"}}>|</span>
                    <a href={academyInfo["Blog"]} target="_blank">블로그</a>
                </>
                }
                {academyInfo["Cafe"] &&
                <>
                    <span style={{marginInline: "5px"}}>|</span>
                    <a href={academyInfo["Cafe"]} target="_blank">카페</a>
                </>
                }
            </div>

            <div ref={notice} className={step2Style['noticeWrap']}></div>
        </div>
    )
}